export default __webpack_public_path__ + "static/media/package_14.33945b79.png";